/**
 * Lot Blending Authorization (QC Supervisor). First round (2026-09-25): the screen only; nothing is
 * saved yet (docs/PROCESSING_BACKEND.md). The tab and the dates live in the URL (QC revamp,
 * 2026-09-27).
 */
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { ListPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { BlendingAuthorizationList } from "@/features/processing/components/blending-authorization-list";

const search = z.object({
  tab: z.enum(["pending", "awaiting", "completed"]).default("pending"),
  from: z.string().optional(),
  to: z.string().optional(),
  q: z.string().optional(),
  page: z.number().int().min(1).default(1),
});

export const Route = createFileRoute("/_app/quality/blending/")({
  validateSearch: search,
  beforeLoad: () => {
    if (!useAuth.getState().can("qc.verify")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { selected, ready } = useFacilities();
  if (!ready) return <ListPageSkeleton />;
  return (
    <BlendingAuthorizationList
      facilityId={selected?.id}
      plantName={selected ? `${selected.name} (${selected.plantCode})` : null}
      search={s}
      onSearch={(next) =>
        void navigate({ search: (prev) => ({ ...prev, ...next }) })
      }
    />
  );
}
